import { z } from "zod";

export const schema = z.object({
  email: z.string().email("Du må oppgi en e-post."),
});

export type ForgotPasswordSchema = z.infer<typeof schema>;
